// extracted by mini-css-extract-plugin
export default {"dialog":"style_dialog__QQHsI","content":"style_content__y6RoB"};